export default __webpack_public_path__ + "static/media/chartsIcon.5ee071a9.svg";